import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestore } from '../../config/firebase';
import { createUser } from '../../store/actions/userActions';
import Payments from '../Payments/Payments';
import lang from './lang';
import './Settings.css';

class Settings extends Component {
    state = { theme: 'default' }

    componentDidMount() {
        this.setState({ theme: this.props.user.theme });
    }

    themeHandler = (e) => {
        const { value } = e.target;
        this.setState({ theme: value });
        // Update theme props reducer
        this.props.createUser({ ...this.props.user, theme: value });
        firestore
            .doc('users/' + this.props.user.id)
            .update({ theme: value });

        firestore
            .doc('users/' + this.props.user.id)
            .collection('sellers')
            .get()
            .then(doc => {
                const batch = firestore.batch();

                doc.docs.forEach(item => {
                    batch.update(item.ref, { theme: value });
                });

                return batch.commit().then(data => {
                    doc.docs.forEach(item => {
                        firestore.collection('sellers').doc(item.id).update({ theme: value })
                    });

                    console.log('All sellers saved theme')
                })
            })


    }

    render() {
        // Translatins
        const {
            title,
            chooseTheme,
            defaultTheme,
            dark,
            payments,
        } = lang[this.props.user.lang || 'en'];

        return (
            <div id="settings-page">
                <h2 className="text-center">{title}</h2>

                <div className="card d-flex">
                    <div className="card-header">
                        <h5>{chooseTheme}</h5>
                    </div>
                    <div className="card-body d-flex">
                        <div className="w-50 px-3">
                            <input
                                type="radio"
                                name="theme"
                                value="default"
                                onChange={this.themeHandler}
                                checked={this.state.theme === 'default' ? true : false}
                            /> {defaultTheme}
                            <div className="progress mt-2" style={{ height: "40px" }}>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--light-bg)" }} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar bg-success" role="progressbar" style={{ width: "25%", height: "50px" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--bg)" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar bg-primary" role="progressbar" style={{ width: "25%", height: "50px" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div className="w-50 px-3">
                            <input
                                type="radio"
                                name="theme"
                                value="dark-theme"
                                onChange={this.themeHandler}
                                checked={this.state.theme === 'dark-theme' ? true : false}
                            /> {dark}
                            <div className="progress mt-2" style={{ height: "40px" }}>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--light-bg)" }} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--green)" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--dark-bg)" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar" role="progressbar" style={{ width: "25%", height: "50px", backgroundColor: "var(--orange)" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card d-flex mt-4">
                    <div className="card-header">
                        <h5>{payments}</h5>
                    </div>

                    <Payments />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createUser: (theme) => dispatch(createUser(theme)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);